"use strict";Object.defineProperties(exports,{__esModule:{value:!0},[Symbol.toStringTag]:{value:"Module"}});const e=require("./Image.js");exports.Image=e;exports.default=e;
//# sourceMappingURL=index.js.map
